var map = {
	"./backgrounds/background.webp": 552,
	"./icons/01.webp": 299,
	"./icons/02.webp": 676,
	"./icons/03.webp": 968,
	"./icons/04.webp": 201,
	"./icons/09.webp": 966,
	"./icons/10.webp": 687,
	"./icons/11.webp": 828,
	"./icons/13.webp": 728,
	"./icons/50.webp": 71
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 226;